<template>
  <div class="tips-wrap">
    <el-checkbox class="checkbox-custom" v-bind="$attrs" v-on="$listeners" />
    <div class="tips-text">{{ $t('login.register.subscribe') }}</div>
  </div>
</template>

<script>
export default {
  name: '',
  methods: {},
}
</script>
<style lang="scss" scoped>
.tips-wrap {
  display: flex;
  margin-bottom: 12px;
}
.checkbox-custom {
  margin-right: 12px;
}
.tips-text {
  color: #5c5c5c;
  font-size: 14px;
  line-height: 22px;
}
</style>
